module.exports = __webpack_public_path__ + "static/media/tenth_southside_school6.38002a1d.png";